import '@/lib/i18n';
import { ThemeProvider } from '@/lib/contexts/theme-context';
import { LocaleProvider } from '@/lib/contexts/locale-context';
import { ApiCacheProvider } from '@/lib/contexts/api-cache-context';
import { AuthProvider } from '@/lib/contexts/auth-context';
import { DevicePermissionsProvider } from '@/lib/contexts/device-permissions-context';

/**
 * Composant composite regroupant tous les providers de l'application.
 * Simplifie app.jsx et centralise la configuration des contextes.
 *
 * Ordre des providers (du plus externe au plus interne) :
 * 1. ThemeProvider - Thème client (CSS vars, branding), aucune dépendance
 * 2. ApiCacheProvider - Cache global, indépendant
 * 3. AuthProvider - Authentification, utilise ApiCacheProvider
 * 4. LocaleProvider - Langue de l'app (i18next + <html lang>), lit useAuth()
 *    pour savoir s'il faut remonter un changement de langue au compte
 * 5. DevicePermissionsProvider - Permissions device (géoloc, caméra)
 *
 * La langue initiale n'attend pas LocaleProvider : elle est résolue à l'import
 * de lib/i18n (première ligne de ce fichier), avant le premier rendu.
 */
export function AppProviders({ children }) {
    return (
        <ThemeProvider>
            <ApiCacheProvider>
                <AuthProvider>
                    <LocaleProvider>
                        <DevicePermissionsProvider>{children}</DevicePermissionsProvider>
                    </LocaleProvider>
                </AuthProvider>
            </ApiCacheProvider>
        </ThemeProvider>
    );
}
